import { IFilters } from 'components/Templates/TemplatesModalV2/Types'
import { useVisualElementsCountsByStyle } from 'hooks/queries/visualElements/useVisualElementsCountsByStyle'
import { getItemWidth, StyleCarousel } from './StyleCarousel'
import { ASPECT_RATIOS, AspectRatioKey } from 'components/NewFileModal/Types'
import Styles from './TemplatesV2.module.scss'
import { EmptyState } from 'components/Wizards/Wizard/Form/TemplateSelect/EmptyState'
import { Carousel } from 'components/Carousel/Carousel'
import { ShimmeringColor } from 'components/BrandWizardVisualAnalysisModal/LoadingState'
import cx from 'classnames'

interface Props {
  filters: IFilters
  onSelect: (templateId: number, aspectRatioKey: AspectRatioKey) => void
  selectedIds?: number[]
  hideFormatLabels?: boolean
  smallPreviews?: boolean
}

const ASPECT_RATIO_KEY_CAROUSEL_MAPPINGS: AspectRatioKey[] = [
  'instagram-square-post',
  'linkedin-post',
  'instagram-portrait-post',
  'instagram-landscape-post',
  'twitter-post',
  'instagram-square-post',
  'facebook-marketplace',
]

const LoadingState = ({ smallPreviews = false }: Pick<Props, 'smallPreviews'>) => {
  return (
    <div className={Styles.styleCarouselsContainer}>
      {ASPECT_RATIO_KEY_CAROUSEL_MAPPINGS.map((aspectRatioKey, i) => {
        const { width, height } = ASPECT_RATIOS[aspectRatioKey]
        return (
          <div className={cx(Styles.styleCarouselRoot, Styles.loadingContainer)} key={i}>
            <div className={Styles.heading}>
              <div className={Styles.shimmeringTitle} />
            </div>
            <Carousel>
              <ShimmeringColor aspectRatio={width / height} width={getItemWidth(width, height, smallPreviews)} />
              <ShimmeringColor aspectRatio={width / height} width={getItemWidth(width, height, smallPreviews)} />
              <ShimmeringColor aspectRatio={width / height} width={getItemWidth(width, height, smallPreviews)} />
              <ShimmeringColor aspectRatio={width / height} width={getItemWidth(width, height, smallPreviews)} />
              <ShimmeringColor aspectRatio={width / height} width={getItemWidth(width, height, smallPreviews)} />
              <ShimmeringColor aspectRatio={width / height} width={getItemWidth(width, height, smallPreviews)} />
            </Carousel>
          </div>
        )
      })}
    </div>
  )
}

export const StyleCarousels = ({
  filters,
  onSelect,
  selectedIds = [],
  hideFormatLabels = false,
  smallPreviews = false,
}: Props) => {
  const { types, styles, categories, query, aspectRatioKey } = filters
  const { data, isLoading } = useVisualElementsCountsByStyle(
    {
      width: aspectRatioKey ? ASPECT_RATIOS[aspectRatioKey].width : undefined,
      height: aspectRatioKey ? ASPECT_RATIOS[aspectRatioKey].height : undefined,
      element_type: 'Template',
      type: types === 'all' ? undefined : ([...types] as string[]),
      style: styles === 'all' ? undefined : ([...styles] as string[]),
      category: categories === 'all' ? undefined : ([...categories] as string[]),
      query: query === '' ? undefined : query,
    },
    {
      cacheTime: 2 * 1000 * 60,
      staleTime: 2 * 1000 * 60,
    },
  )
  const populatedStyles = data ? Object.keys(data) : []

  if (isLoading) {
    return <LoadingState smallPreviews={smallPreviews} />
  }

  if (populatedStyles.length === 0) {
    return <EmptyState />
  }

  return (
    <div className={Styles.styleCarouselsContainer}>
      {populatedStyles.map((style, i) => {
        const aspectRatioKey =
          filters.aspectRatioKey ?? ASPECT_RATIO_KEY_CAROUSEL_MAPPINGS[i] ?? ASPECT_RATIO_KEY_CAROUSEL_MAPPINGS[0]

        return (
          <StyleCarousel
            key={i}
            style={style}
            filters={filters}
            aspectRatioKey={aspectRatioKey}
            onSelect={onSelect}
            selectedIds={selectedIds}
            hideFormatLabels={hideFormatLabels}
            smallPreviews={smallPreviews}
          />
        )
      })}
    </div>
  )
}
